
import { defineComponent, onMounted, reactive, ref, watch } from "vue";

interface State {
  hasLoaded: boolean;
  aspectClass: string;
}

// <!-- src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" -->

export default defineComponent({
  name: "PhotoWork",
  props: {
    dataSrc: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    isLoad: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    // state object.
    const state = reactive<State>({
      hasLoaded: false,
      aspectClass: "before-loading"
    });

    // ref for image.
    const imageRef = ref<HTMLImageElement>();

    // puts mat-pattern.png
    document.documentElement.style.setProperty(
      "--url-mat",
      `url("${process.env.BASE_URL}image/mat-pattern.png")`
    );
    document.documentElement.style.setProperty(
      "--url-sig",
      `url("${process.env.BASE_URL}image/signature.png")`
    );

    // upon mounted.
    onMounted(() => {
      if (!imageRef.value) return;
      const image = imageRef.value;
      image.onload = () => {
        state.aspectClass = (() => {
          if (image.naturalWidth == image.naturalHeight) return "square";
          return image.naturalWidth > image.naturalHeight
            ? "landscape"
            : "portrait";
        })();
        state.hasLoaded = true;
      };
      image.onerror = e => {
        console.log(e);
      };
      if (!state.hasLoaded && props.isLoad && props.dataSrc.length > 0) {
        image.src = props.dataSrc;
      }
    });
    watch(
      () => props.dataSrc,
      (newDataSrc, oldDataSrc) => {
        if (newDataSrc !== oldDataSrc) {
          state.hasLoaded = false;
        }
        if (!imageRef.value) return;
        imageRef.value.src = newDataSrc;
      }
    );
    return {
      state,
      imageRef
    };
  }
});
